module.exports = __webpack_public_path__ + "img/wedo_pict06.3aaaab48.png";